import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quanjian",
  "use": "icon-quanjian-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-quanjian\">\r\n<rect width=\"18\" height=\"18\" rx=\"9\" fill=\"#FF7463\" />\r\n<rect x=\"4\" y=\"8\" width=\"10\" height=\"2\" rx=\"1\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol